import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { TeamworkGraphPreviewPanelOpenGraphButton } from './TeamworkGraphPreviewPanelOpenGraphButton.tsx';

const styles = cssMap({
	footer: {
		flexShrink: 0,
		boxSizing: 'border-box',
		display: 'flex',
		alignItems: 'center',
		paddingBlock: token('space.200'),
		paddingInline: token('space.300'),
		borderTopStyle: 'solid',
		borderTopWidth: token('border.width'),
		borderTopColor: token('color.border'),
		backgroundColor: token('elevation.surface'),
	},
});

export function TeamworkGraphPreviewPanelFooter({
	onOpenGraph,
	testId,
}: {
	onOpenGraph: () => void;
	testId?: string;
}): React.JSX.Element {
	return (
		<Box as="footer" testId={testId} xcss={styles.footer}>
			<TeamworkGraphPreviewPanelOpenGraphButton
				onClick={onOpenGraph}
				testId={testId && `${testId}-open-graph`}
			/>
		</Box>
	);
}
